import { toIdFromHex } from '#~/api/index.js';
import { config } from '#~/config/index.js';
import { StudioError } from '#~/error/index.js';
import { nats } from '#~/nats/index.js';
import { BillingRegistryContactSalesRequest } from '@tryiris-ai/common.protojs/api/v1/billing_registry';
import { BillingRegistryContactSales } from '@tryiris-ai/mailroom-helper/billing';
import type { Room } from '@studio/models/room';

/**
 * Send request contact
 *
 * @param roomID - The ID of the room.
 * @param token - The token for authentication.
 */
export const SendContactSalesRequest = async (roomId: Room['id'], token: string) => {
  try {
    await BillingRegistryContactSales.request(
      nats.cloudConnection(),
      BillingRegistryContactSalesRequest.fromPartial({
        roomID: toIdFromHex(roomId)!,
        token: token,
        domain: new URL(config.frontendUrl).hostname
      })
    );
  } catch (e) {
    throw new StudioError(`Error sending request to contact sales`);
  }
};
